import { FC } from "react";
import { IconProps } from "@shared/ui/Icon/ui/types";

export const WarnIcon: FC<IconProps> = ({ className }) => (
    <svg
        className={className}
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle cx="7.5" cy="7.5" r="7.5" fill="#B5BCCB" fillOpacity="0.56" />
        <path
            d="M6.91008 9.216L6.62208 3.6H8.39808L8.09808 9.216H6.91008ZM7.51008 12.084C7.23008 12.084 6.99808 11.992 6.81408 11.808C6.63008 11.624 6.53808 11.404 6.53808 11.148C6.53808 10.892 6.63008 10.676 6.81408 10.5C6.99808 10.316 7.23008 10.224 7.51008 10.224C7.79008 10.224 8.01808 10.316 8.19408 10.5C8.37008 10.676 8.45808 10.892 8.45808 11.148C8.45808 11.404 8.37008 11.624 8.19408 11.808C8.01808 11.992 7.79008 12.084 7.51008 12.084Z"
            fill="white"
        />
    </svg>
);